export default __webpack_public_path__ + "static/media/Sanchi1_N-MP-220-1024x685.b98d12f6.jpg";